module.exports = __webpack_public_path__ + "static/media/16UNODC33.03d13155.jpg";